import { Lightning } from "@lightningjs/sdk";
/** Rasterise vector club badges through Lightning's SVG loader, not its image worker. */
export function gameLogo(src, w, h) {
    return src.endsWith(".svg")
        ? {
            texture: Lightning.Tools.getSvgTexture(src, Math.ceil(w * 2), Math.ceil(h * 2)),
        }
        : { src };
}
export default gameLogo;
//# sourceMappingURL=gameLogo.js.map